// extracted by mini-css-extract-plugin
module.exports = {"banner":"EKywmLT7","box":"_3qWU97Mv","btn":"_1cwQjzx_","textBtn":"_1krTRSbN","center":"_1jqUSkqi","text":"_2wgfCJ_8","text24":"_1uapq_YA","mb64":"_2kkVaMfP"};